export default "__VITE_ASSET__40jC09hh__"